module.exports = __webpack_public_path__ + "img/scity.41c106c0.jpg";